/* eslint formatjs/no-literal-string-in-jsx: "error" */
import React from "react"
import { FormattedMessage, useIntl } from "react-intl"
import { RegistrationFlowLayout } from "./RegistrationLayouts"
import { RegistrationButtonFooter } from "./RegistrationButtons"
import { Button, Typography } from "@carrotfertility/carotene-core"
import { RegistrationFlowTitle } from "./RegistrationFlowTitle"

export function RegistrationComplete(): JSX.Element {
  const intl = useIntl()
  const header = intl.formatMessage({ defaultMessage: "Thanks." })
  function onComplete(): void {
    window.location.href = "/"
  }
  return (
    <>
      <RegistrationFlowTitle title={header} />
      <RegistrationFlowLayout
        header={header}
        imageName="illo-underwater-dashboard"
        description={
          <Typography>
            <FormattedMessage defaultMessage="We're so glad you're here." />
          </Typography>
        }
        interactiveElements={
          <RegistrationButtonFooter
            continueButton={
              <Button onClick={onComplete} color="primary" variant="contained">
                <FormattedMessage defaultMessage="Go to Carrot home" />
              </Button>
            }
          />
        }
      />
    </>
  )
}
